import { render, staticRenderFns } from "./RevenueContent.vue?vue&type=template&id=658c81e4&scoped=true"
import script from "./RevenueContent.vue?vue&type=script&lang=js"
export * from "./RevenueContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c81e4",
  null
  
)

/* custom blocks */
import block0 from "./RevenueContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports